// extracted by mini-css-extract-plugin
export default {"container":"Note_container__IcCsR","timestamp":"Note_timestamp__YPg2x","divider":"Note_divider__Y+weZ","content":"Note_content__8TJ17"};